import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { EditableCustomerRow } from "@/components/shared/EditableCustomerRow";
import PoLinkStatus from "@/components/customers/PoLinkStatus";
import { InfoRow } from "./BudgetTab";
import { CustomerPicker } from "./CustomerPicker";
import type { DBProject } from "@/lib/db-types";
import type { CustomerInfo } from "@/hooks/use-project-detail";

/**
 * Kundeinfo-kortet under prosjektets Innstillinger. Skilt ut av
 * InnstillingerTab (VIB-2575) da PO-koblingsstatus og postnummer/poststed
 * kom til.
 */
export function ProjectCustomerCard({
  project: p,
  customer,
}: {
  project: DBProject;
  customer: CustomerInfo | null;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Kundeinfo</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
        <CustomerPicker
          projectId={p.id}
          projectUpdatedAt={p.updated_at}
          currentCustomerId={customer?.id ?? null}
          currentCustomerName={customer?.name ?? null}
        />
        {customer && (
          <>
            {!p.is_internal && (
              <PoLinkStatus
                customerId={customer.id}
                poCustomerId={customer.poweroffice_customer_id}
                projectId={p.id}
              />
            )}
            <InfoRow label="Org.nr" value={customer.organization_number} />
            <EditableCustomerRow
              label="Kontaktperson"
              value={customer.contact_person}
              field="contact_person"
              customerId={customer.id}
            />
            <EditableCustomerRow
              label="E-post"
              value={customer.contact_email}
              field="contact_email"
              customerId={customer.id}
            />
            {/*
              VIB-2521/2531: fakturaen sendes IKKE til kontakt-e-posten
              over. Setter vi ikke projects.invoice_email, bruker PO
              kundens InvoiceEmailAddress — dette feltet. Det må stå for
              seg selv, ellers retter folk feil felt når en kunde bytter
              fakturaadresse.
            */}
            <EditableCustomerRow
              label="Faktura-e-post"
              value={customer.invoice_email_address}
              field="invoice_email_address"
              customerId={customer.id}
              hint="Hit sendes fakturaen når prosjektet ikke overstyrer."
            />
            <EditableCustomerRow
              label="Faktura-kopi"
              value={customer.invoice_email_cc}
              field="invoice_email_cc"
              customerId={customer.id}
            />
            <EditableCustomerRow
              label="Adresse"
              value={customer.address}
              field="address"
              customerId={customer.id}
            />
            {/* VIB-2575: PO krever postnummer og poststed for utenlandske kunder. */}
            <EditableCustomerRow
              label="Postnummer"
              value={customer.postal_code}
              field="postal_code"
              customerId={customer.id}
            />
            <EditableCustomerRow
              label="Poststed"
              value={customer.city}
              field="city"
              customerId={customer.id}
            />
          </>
        )}
      </CardContent>
    </Card>
  );
}
